import { createContext } from 'react';
import type { AuthProviderId } from '@/config/env';
import type { AuthUser } from './types';

export type AuthStatus = 'loading' | 'authenticated' | 'unauthenticated';

export interface AuthContextValue {
  status: AuthStatus;
  user: AuthUser | null;
  providerId: AuthProviderId;
  signInWithGoogle(options?: { returnTo?: string }): Promise<AuthUser>;
  completeRedirectSignIn(code: string, appVerifier?: string): Promise<AuthUser>;
  signInAsDevUser(email: string): Promise<AuthUser>;
  signOut(): Promise<void>;
  getAccessToken(options?: { forceRefresh?: boolean }): Promise<string | null>;
}

export const AuthContext = createContext<AuthContextValue | null>(null);
